export default "__VITE_ASSET__d59cef16__"